<div class="wrap-login100">
    <div class="login100-pic js-tilt">
        <img src="assets/images/logo2.png" alt="IMG">
    </div>

    <form class="login100-form validate-form">
        <span *ngIf="step==2" class="login100-form-title">
            Iscription
        </span>
        <span *ngIf="step==3" class="login100-form-title">
            Mot de passe oublié
        </span>
        <span *ngIf="step==1" class="login100-form-title">
            Connexion
        </span>
        <div class="wrap-input100 validate-input" *ngIf="step==2">
            <input class="input100" type="text" [(ngModel)]="user.lastname" name="lastname" placeholder="Nom complet">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="wrap-input100 validate-input" *ngIf="step==2">
            <input class="input100" type="text" [(ngModel)]="user.phone" name="phone" placeholder="Téléphone">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="wrap-input100 validate-input">
            <input class="input100" type="text" [(ngModel)]="user.email" name="email" placeholder="Email">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
                <!-- <i class="flaticon-gmail-logo"></i> -->
            </span>
        </div>
        <div class="wrap-input100 validate-input" *ngIf="step==1 || step==2">
            <input class="input100" type="password" [(ngModel)]="user.password" spellcheck=false name="pass"
                placeholder="Mot de passe">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="wrap-input100 validate-input" *ngIf="step==2">
            <input class="input100" type="password" [(ngModel)]="user.confirmePassword" spellcheck=false
                name="confirmePassword" placeholder="Confimer votre mot de passe">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>


        <div class="container-login100-form-btn">
            <button *ngIf="step==1" class="login100-form-btn" (click)="login()" [disabled]="loader">
                <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                </ng-container>
                Se connecter
            </button>
            <button *ngIf="step==2" class="login100-form-btn" (click)="signup()" [disabled]="loader">
                <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                </ng-container>
                S'inscrire
            </button>
            <button *ngIf="step==3" class="login100-form-btn" (click)="sendPassword()" [disabled]="loader">
                <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                </ng-container>
                Envoyer
            </button>
        </div>
        <div class="footer">
            <div class="text-center a1">
                <a class="txt2 cursor-pointer" (click)="step=3" *ngIf="step==1">
                    Mot de passe oublié?
                </a>
            </div>

            <div class="text-center a2">
                <button (click)="step=1" *ngIf="step==3 || step==2" class="login-btn">
                    Se connecter &nbsp;&nbsp;
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </button>
                <button (click)="step=2" *ngIf="step==1" class="login-btn">
                    S'inscrire &nbsp;&nbsp;
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </button>
            </div>
        </div>
        <ng-container *ngIf="step==2">
            <div class="form-group" *ngIf="step==2">
                <p>Aprés l'inscription, merci de consulter votre boite email pour valider votre inscription.</p>
            </div>
        </ng-container>
        <ng-container *ngIf="step==3">
            <p>
                Merci de consulter votre boite email pour obtenir votre mot de passe après la validation..
            </p>
        </ng-container>
    </form>
</div>